import { render } from "./MarketplaceMenuMobile.vue?vue&type=template&id=09a4cb54&scoped=true"
import script from "./MarketplaceMenuMobile.vue?vue&type=script&lang=js"
export * from "./MarketplaceMenuMobile.vue?vue&type=script&lang=js"

import "./MarketplaceMenuMobile.vue?vue&type=style&index=0&id=09a4cb54&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a4cb54"]])

export default __exports__